module.exports = __webpack_public_path__ + "img/icon_map_38_on_110.c4978abc.png";